import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogOut = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14 21.5H5C3.89543 21.5 3 20.6046 3 19.5V5.5C3 4.39543 3.89543 3.5 5 3.5H14C15.1046 3.5 16 4.39543 16 5.5V9.5H14V5.5H5V19.5H14V15.5H16V19.5C16 20.6046 15.1046 21.5 14 21.5ZM18 13.5V16.5L23 12.5L18 8.5V11.5H9V13.5H18Z",
		fill: "white"
	})
});
export { SvgLogOut as ReactComponent };
